module.exports = __webpack_public_path__ + "static/media/pengajuan.584d8196.svg";